import axios from "axios";
import {
	v4 as uuidv4
} from 'uuid';

const state = {
	posts: [],
	postsCount: 0,

	post: {
		post_json: "{}",
		title: "",
		draft: "true",
		tags:[],
		editors: [],
	},

	category_tags: [],
	category: "",
	subcategory: "",

	postParams: {
		q: "",
		limit: 20,
		offset: 0,
		tag: ""
	},
	nextPostUrl: "",

	indexPost: 0,

	viewPostPage: {name: "post-listing"}
};

const actions = {
	async loadPosts(context) {
		return axios.get("/api/1/posts/" + encodeURIComponent(context.state.category), { params: context.state.postParams }).then(function (response) {

			if (response.data.success == false) {
				throw "User permissions";
			}
			context.commit("setPostNext", response.data.next);
			context.commit("setPosts", response.data.result);
			context.commit("setCategoryTags", response.data.tags);
		})
	},
	async loadMorePosts(context) {
		if (!context.state.nextPostUrl) {
			return;
		}
		return axios.get(context.state.nextPostUrl).then(function (response) {
			context.commit("setPostNext", response.data.next);
			context.commit("appendPosts", response.data.result);
			
		})
	},

	async loadOrderedPosts(context){
		var params = context.state.postParams;
		params.category = context.state.category;
		return axios.get("/api/1/orderedPosts", { params }).then(function (response) {


			if (response.data.success == false) {
				throw "User permissions";
			}
			
			context.commit("setPostCount", response.data.result_count);
			context.commit("setPosts", response.data.result);
			context.commit("setCategoryTags", response.data.tags);
		})
	},

	async loadMorePostsOrdered(context) {
		var params = context.state.postParams;
		params.category = context.state.category;

		if(!params.offset){
			params.offset = 0;
		}

		params.offset = params.offset + 20,
        params.limit = 20;


		return axios.get("/api/1/orderedPosts", { params }).then(function (response) {
			context.commit("setPostCount", response.data.result_count);
			context.commit("appendPosts", response.data.result);
		})
	},
	async loadSubPosts(context) {
		return axios.get("/api/1/subposts/" + context.state.category, { params: context.state.postParams }).then(function (response) {
			
			if (response.data.success == false) {
				throw "User permissions";
			}
			context.commit("setPostNext", response.data.next);
			context.commit("setPosts", response.data.result);
			context.commit("setCategoryTags", response.data.tags);
		})
	},
	async loadMoreSubPosts(context) {
		if (!context.state.nextPostUrl) {
			return;
		}
		return axios.get(context.state.nextPostUrl).then(function (response) {
			context.commit("setPostNext", response.data.next);
			context.commit("appendPosts", response.data.result);
			
		})
	},
	async loadPostListing(context) {
		var params = context.state.postParams;
		params.category = context.state.category;
		return axios.get("/api/1/postlisting", { params }).then(function (response) {


			if (response.data.success == false) {
				throw "User permissions";
			}
			
			context.commit("setPostCount", response.data.result_count);
			context.commit("setPosts", response.data.result);
			context.commit("setCategoryTags", response.data.tags);
		})
	},
	async loadMorePostListings(context) {
		var params = context.state.postParams;
		params.category = context.state.category;
		return axios.get("/api/1/postlisting", { params }).then(function (response) {
			context.commit("setPostCount", response.data.result_count);
			context.commit("appendPosts", response.data.result);
		})
	},
	async reloadPostListings(context) {
		var params = JSON.parse(JSON.stringify(context.state.postParams));
		params.category = context.state.category;
		params.limit = params.offset + params.limit;
		params.offset = 0;
		return axios.get("/api/1/postlisting", { params }).then(function (response) {
			context.commit("setPostCount", response.data.result_count);
			context.commit("setPosts", response.data.result);
		})
	},
	async loadMorePostReview(context) {



		var params = {
			offset: 0,
			limit: 20,
			reviewing:"true",
			q:context.state.postParams.q,
			tag: context.state.postParams.tag
		};

		params.category = context.state.category
		return axios.get("/api/1/postlisting", { params }).then(function (response) {
			context.commit("appendPosts", response.data.result);
		})
	},
	async loadTaggedPosts(context) {
		return axios.get("/api/1/tags/post", { params: context.state.postParams }).then(function (response) {
			
			context.commit("setPostNext", response.data.next);
			context.commit("setPosts", response.data.result);
		})
	},
	async searchPosts(context) {
		return axios.get("/api/1/search/posts/", { params: context.state.postParams }).then(function (response) {
			
			if (response.data.success == false) {
				throw "User permissions";
			}
			context.commit("setPostNext", response.data.next);
			context.commit("setPosts", response.data.result);
		})
	},

	async getPostInfo(context, postid) {
		return axios.get("/api/1/post", { params: { postid: postid, category: context.state.category } }).then(function (response) {
			if (response.data.success == false) {
				throw "User permissions";
			}
			
			context.commit("setPost", response.data)
		})
	},

	resetPost(context) {
        context.commit('clearPost');
	},

	updateCategory(context, category) {
		context.commit("setCategory", category)
	},

	updatePostParams(context, params) {
		context.commit("setPostParams", params)
	},	
	
	updateViewPostPage(context, page) {
		context.commit("setViewPostPage", page)
	},

	//RESETS POSTS SO NAVIGATION WORKS SEAMLESSLY
	resetPosts(context) {
		context.commit('clearPosts');
	},

	resetIndexPost(context) {
		context.commit('clearIndexPost');
	},

	updateIndexPost(context, index) {
		context.commit("setIndexPost", index);
	},
}

const mutations = {
	setIndexPost(state, index) {
		state.indexPost = index;
	},
	clearIndexPost(state) {
		state.indexPost = 0;
	},
	clearPosts(state) {
		state.posts = [];
	},
	setPosts(state, posts) {
		state.posts = posts;
	},
	setCategoryTags(state, tags) {
		state.category_tags = tags;
	},
	appendPosts(state, data) {
		state.posts = state.posts.concat(data);
		
		
	},
	clearPost(state){
        state.post =  {
			post_json: "{}",
			title: "",
			draft: "true",
			tags:[],
			editors: [],
        };
    },
	setPost(state, data) {
		state.post = data.result;
		state.post.tags = data.tags;
		state.post.editors = data.editors;
		if (data.result.json) {
			state.post.json = JSON.parse(data.result.json);
		}
	},
	setPostCount(state, data) {
		state.postsCount = data;
	},
	setPostParams(state, params) {
		state.postParams = params;

	},	
	setViewPostPage(state, page) {
		state.viewPostPage = page;
	},
	setCategory(state, category) {
		state.category = category
	},
	setPostNext(state, data) {
		state.nextPostUrl = data;
	},
}

const getters = {
	nextPostUrl(state) {
		return state.nextPostUrl;
	},
	indexPost(state) {
		return state.indexPost;
	},

	postParams(state) {
		return state.postParams;
	},
	posts(state) {
		return state.posts;
	},
	post(state) {
		return state.post;
	},
	viewPostPage(state) {
		return state.viewPostPage;
	},
	postsCount(state){
		return state.postsCount;
	},
	category(state) {
		return state.category;
	},
	activeCategory(state) {
		return state.category;
	},		
	subcategory(state) {
		return state.subcategory;
	},
	category_tags(state) {
		return state.category_tags;
	}
};

export default {
	state,
	actions,
	mutations,
	getters
};